import { FunctionalComponent, h, } from 'preact';
import Container from '../../components/container';
import WrapperComponent from '../../components/hoc/WrapperComponent';

const HomeScene: FunctionalComponent = () => {
  return (
    <Container />
  );
};

export default WrapperComponent('HomeScene')(HomeScene);
